<template>
    <div class="row mb-2 align-items-center bb-text">
        <div class="col-7">
            <label>{{ player.user_name }}</label>
        </div>
        <div class="col text-end">
            <img v-bind:src="player.avatar_image" height="70" width="70"
                class="rounded-circle border border-dark bb-image-container" alt="Player Avatar" />
        </div>
    </div>
</template>

<script>
export default {
    name: 'CampaignCardPlayerComponent',
    props: {
        player: {
            type: Object,
            required: true,
        },
    },
}
</script>
